// Models

PJQ.models.featureSettings = {};

PJQ.models.featureSettings.FeatureSetting = PJQ.models.BaseModel.extend({
    endpoint: function () {
        if(this.options.project) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: PJQ.app.session.project.get('projectId')
                },
                {
                    endpoint: 'featuresettings'
                }
            ])
        }
        else{
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'settings'
                },
                {
                    endpoint: 'featuresettings'
                }
            ])
        }
    },
});


// Views

PJQ.views.featureSettings = {};

PJQ.views.featureSettings.FeatureSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'feature-settings')
    },
    events: {

    },
    beforeFirstRender: function() {
        if(this.model && !this.options.project && !this.model.isFetched){
            this.model.fetch({
                success: _.bind(function(){
                    this.render();
                }, this)
            })
        }
        else{
            this.render();
        }
    },
    renderData: function () {
        return {
            model: this.model,
            project: this.options.project
        }
    },
    afterRender: function() {
        new PJQ.Binder(this.$('.settings'), this.model, {
            setDefaultValues: true,
            watchElements: [
                'input'
            ],
            afterChange: _.bind(function () {
                this.onChange();
            }, this)
        });
    },
    onChange: function() {
        if(typeof this.options.onChange === 'function'){
            this.options.onChange(this.model);
        }
    }
})

PJQ.views.featureSettings.FeatureSettingsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Feature-Settings'),
        minWidth: 700
    },
    defaultEvents: {
        'click .btn-save': 'save',
        'click .btn-cancel': 'cancel'
    },
    renderData: function () {
        return {
            model: this.model,
            project: this.options.project
        };
    },
    afterRender: function () {
        new PJQ.views.featureSettings.FeatureSettings({
            el: this.$('.feature-settings'),
            project: this.options.project,
            model: this.model
        })
    },
    save: function() {
        this.model.save(null, {
            success: _.bind(function(featureSettings) {
                PJQ.app.session.project.set('featureSettings', featureSettings.toJSON());
                PJQ.app.navigator.refreshCommands();
                PJQ.app.navigator.renderHeader();
                this.removeModal();
            }, this)
        })
    },
    cancel: function() {
        this.removeModal();
    }
});
